<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div style="margin: 15px 0 20px 0;">
        <el-date-picker v-model="value" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :editable="false" @change="chooseTime">
        </el-date-picker>
        <el-input v-model="inputVal" class="input_s200" placeholder="请输入订单号/姓名/手机" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
      </div>
      <el-table :data="tableData" tooltip-effect="light">
        <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="姓名" width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.name == '散客' ? '新增顾客' : scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderTime" label="开单时间" width="170">
        </el-table-column>
        <el-table-column prop="money" label="金额（元）">
        </el-table-column>
        <el-table-column label="项目︱产品" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <yz-btn type="primary" @click="lookOrder(scope.row)">详情</yz-btn>
            <yz-btn type="primary" @click="editOrder(scope.row.orderId)">修改</yz-btn>
            <yz-btn type="primary" @click="settlementOrder(scope.row.orderId)">结算</yz-btn>
            <yz-btn type="delete" @click="delOrder(scope.row.orderId)">删除</yz-btn>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>

      <el-dialog :title="'订单号：'+orderCode" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
        <yz-order-deatils :order-deatils-data="orderDeatilsData" :loading="loading2" @tansferDialog="getDialogData"></yz-order-deatils>
      </el-dialog>

      <gt-delDig @delData="getDelData"></gt-delDig>
    </div>
  </div>
</template>

<script>
import { getOrderDetails, getIndexOrderList } from '../../api';
import YzOrderDeatils from '../../../stage/template/orderDetails/index';

export default {
  components: {
    YzOrderDeatils
  },
  data() {
    return {
      value: '',
      inputVal: '',
      tableData: [],
      pageNum: 1,
      rowCount: 0,
      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
      orderDeatilsDialog: false,
      orderCode: '',
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
      // 5.7
      loading: true,
      loading2: true,
    };
  },
  watch: {
    'delForm.status': function (val) {
      if (val == true) {
        this.getListData();
      }
    }
  },
  activated() {
    this.getListData();
  },
  methods: {
    // 搜索
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.getListData();
    },
    // 加载未完成订单列表
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getIndexOrderList(data).then((res) => {
        if (res.code == 0) {
          if (vm.pageNum != 1 && res.data.records.length == 0) {
            vm.pageNum--;
            vm.getListData();
          } else {
            vm.tableData = res.data.records;
            vm.rowCount = res.data.total;
          }
        } else {
          vm.tableData = [];
          vm.rowCount = 0;
        }
      });
    },
    // 选择时间
    chooseTime() {
      this.pageNum = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 查看订单
    lookOrder(row) {
      const { orderId } = row;
      this.loading2 = true;
      this.orderDeatilsDialog = true;
      getOrderDetails({ id: orderId }).then((res) => {
        if (res.code === 0) {
          const arr = [];
          res.data.serveItemsList ? res.data.serveItemsList : res.data.serveItemsList = [];
          res.data.productSalesList ? res.data.productSalesList : res.data.productSalesList = [];
          res.data.vipCardList ? res.data.vipCardList : res.data.vipCardList = [];
          res.data.memberMsg ? res.data.memberMsg = res.data.memberMsg : res.data.memberMsg = {};
          res.data.serveItemsList.forEach((a) => {
            a.listStatus = 1;
            arr.push(a);
          });
          res.data.productSalesList.forEach((b) => {
            b.listStatus = 2;
            b.resultPrice = b.total;
            arr.push(b);
          });
          res.data.vipCardList.forEach((c) => {
            c.listStatus = 3;
            arr.push(c);
          });
          res.data.consumptionList = arr;
          res.data.newStatus = 1;
          this.orderDeatilsData = res.data;
          this.orderCode = row.orderCode;
          this.loading2 = false;
        }
      });
    },
    // 修改订单
    editOrder(id) {
      window.sessionStorage.editOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling',
      });
    },
    // 结算订单
    settlementOrder(id) {
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement',
      });
    },
    // 删除订单
    delOrder(id) {
      this.delForm.delDiglogStatus = true;
      this.delForm.id = id;
      this.delForm.title = '提示';
      this.delForm.url = 'deleteOrder';
      this.delForm.text1 = '确认要删除这条订单吗？';
      this.delForm.text2 = '删除后订单数据将无法恢复';
      this.delForm.status = false;
    },
    // 调用公共组件--赋值
    getDelData(list) {
      this.delForm = list;
    },
    // 调用公共组件--赋值
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
  }
};
</script>
